<style lang="scss" scoped>
.city-picker {
    background-color: white;
    position: relative;
    width: auto;
    display: inline-block;
}
.triange {
    width: 0;
    height: 0;
    border: 4px solid #000;
    border-left: none;
    border-style: dashed;
}
.select-container {
    position: absolute;
    min-height: 100px;
    width: 490px;
    border-radius: 2px;
    // box-shadow: 0 3px 9px rgba(0, 0, 0, 0.2);
    box-shadow: 2px 2px 9px rgba(0,0,0,.5);
    left: 50%;
    top: 24px;
    z-index: 9999 !important;
    margin-left: -245px;
    background-color: white;
    font-size: 0;
    .container-header {
        height: 36px;
        background-color: #efefef;
        position: relative;
        .icon-close-win {
            position: absolute;
            top: 50%;
            right: 15px;
            cursor: pointer;
            transform: translateY(-50%);
        }
        ul {
            height: 30px;
            position: absolute;
            bottom: 0;
            line-height: 30px;
            margin-left: 12px;
        }
        li {
            font-size: 12px;
            background-color: white;
            vertical-align: middle;
            border-top-left-radius: 2px;
            border-top-right-radius: 2px;
            width: 80px;
            text-align: center;
            margin-right: 5px;
            display: inline-block;
            cursor: pointer;
        }
    }
    .container-content {
        padding: 15px 2px;
        li {
            box-sizing: border-box;
            width: 97px;
            font-size: 12px;
            line-height: 20px;
            margin: 6px 0;
            display: inline-block;
            text-align: center;
            &:hover {
                background-color: #f3f3f3;
            }
            &:nth-child(5n) {
                margin-right: 0;
            }
            a {
                display: inline-block;
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>

<template>
    <div class="city-picker">
        <a href="javascript:;" @click.prevent="reset">
            {{currentCity}}
            <i class="icons icon-more-big icon-arrow"></i>
        </a>
        <div class="select-container" v-show="show">
            <div class="container-header">
                <i class="icons icon-close-win" @click="show=false"></i>
                <ul>
                    <li v-for="(city, index) in selectCity" @click="reselect(city, index)">
                        {{city}}
                        <i class="icons icon-more-big icon-arrow"></i>
                    </li>
                    <li>请选择
                        <i class="icons icon-more-big icon-arrow"></i>
                    </li>
                </ul>
            </div>
            <div class="container-content">
                <ul>
                    <li v-for="(val, key) in citys">
                        <a href="javascript:;" @click="select(key)">{{key}}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import * as cityMap from '@/data/citys'
export default {
    name: 'cityPicker',
    props: ['local'],
    data() {
        return {
            citys: cityMap,
            selectCity: [],
            currentCity: '',
            show: false
        }
    },
    created() {
        this.currentCity = this.local
    },
    mounted() {
        document.addEventListener('click', this.clickOutHandler)
    },
    methods: {
        select(key) {
            if (!isNaN(this.citys[key])) {
                this.currentCity = key
                this.show = false
                this.$emit('change', this.citys[key])
                return
            }
            this.selectCity.push(key)
            this.citys = this.citys[key]
        },
        reselect(city, index) {
            this.citys = cityMap
            this.selectCity.splice(index)
            for (let city of this.selectCity) {
                this.citys = this.citys[city]
            }
        },
        reset() {
            this.citys = cityMap
            this.selectCity = []
            this.show = true
        },
        clickOutHandler(e) {
            if (!document.querySelector('.city-picker').contains(e.target)) {
                this.show = false
            }
        }
    },
    destroyed() {
        document.removeEventListener('click', this.clickOutHandler)
    }
}
</script>



// WEBPACK FOOTER //
// src/components/city-picker.vue